// import { getCurrentInstance, ComponentInternalInstance } from '@vue/composition-api';
import _ from 'lodash';
import { SMH } from '@/renderer/scripts/smh';
import store from '@/renderer/store';
import {
  isAllowEditDoc,
  isAllowPreviewAudio,
  isAllowPreviewImage,
  isAllowPreviewVideo,
  isAllowEsign,
  isAllowPrivate,
} from '@/renderer/scripts/composition/allowPreview';
import { IS_PRIVATE } from '@/common/constant/platform';
export type TableItem = {
  authorityList: SMH.AuthorityList;
  name?: string;
  previewByDoc?: boolean;
  type?: string;
  userId?: string; // 当前文件所属用户id
};

export type operateType =
  | 'Authorize'
  | 'Delete'
  | 'Download'
  | 'Modify'
  | 'Preview'
  | 'Share'
  | 'Upload'
  | 'View'
  | 'Edit'
  | 'Sync'
  | 'Esign';

// 基本操作权限
// 1、首先判断 canPreview，无权限
// 2、再判断 canPreviewSelf，有权限
//  2.1、判断文件是否是当前登录用户创建的
//  - 是，有权限
//  - 否，无权限
export function can(act: operateType, item: TableItem): boolean {
  const action = `can${act}`;
  if (['Preview', 'Download'].includes(act)) {
    const actionWithSelf = `can${act}Self`;
    // @ts-ignore
    if (item?.authorityList && !item?.authorityList[action]) {
      // @ts-ignore
      if (item?.authorityList && item?.authorityList[actionWithSelf]) {
        return item?.userId === String(store.getters.userId);
      }
      return false;
    }
    // @ts-ignore
    return item?.authorityList && item?.authorityList[action];
  }
  // @ts-ignore
  return item?.authorityList && item?.authorityList[action];
}
export function canBatch(act: operateType, itemList: TableItem[]): boolean {
  if (itemList.length === 0) {
    return false;
  }
  const res = itemList.filter(item => can(act, item));
  return res.length > 0;
}

// 较多条件的操作权限
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function optAuth(
  act: operateType,
  item: SMH.SpaceFileItemData | SMH.RelatedToMeFileItemData,
  params?: any,
): boolean {
  let res: boolean | undefined = true;
  switch (act) {
    case 'Preview':
      if (IS_PRIVATE) {
        // 暂时兼容item.previewByCI && item.previewByDoc，后面将只利用previewByCI字段
        res = (isAllowPrivate(item.name as string) || (item.previewByCI && item.previewByDoc)) && can('Preview', item);
      } else {
        res =
          (isAllowPreviewImage(item.name as string) ||
            isAllowPreviewVideo(item.name as string) ||
            isAllowPreviewAudio(item.name as string) ||
            (item.previewByCI && item.previewByDoc)) &&
          can('Preview', item);
      }
      break;
    case 'Edit':
      res =
        item.previewByCI &&
        item.previewByDoc &&
        isAllowEditDoc(item.name as string) &&
        can('Modify', item) &&
        store.getters.enableDocEdit;
      break;
    case 'Esign':
      res = item.previewByDoc && isAllowEsign(item.name as string) && can('Modify', item);
      break;
    case 'Download':
      res = can('Download', item);
      break;
    case 'Sync':
      if (item.localSync || item.hasSync || item.type !== 'dir') res = false;
      else res = true;
      break;
    default:
      res = false;
      break;
  }
  return res as boolean;
}
